import { render } from "./index.vue?vue&type=template&id=f0601d74&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f0601d74&scoped=true&lang=scss"

import exportComponent from "/Users/yangshaohua/work/workspace/school-b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0601d74"]])

export default __exports__